var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { space } from 'styled-system';
import SVG from 'react-inlinesvg';
export var StyleSVG = styled(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  width: ", ";\n  height: ", ";\n\n  fill: ", ";\n  \n  cursor: ", ";\n"], ["\n  ", "\n  width: ", ";\n  height: ", ";\n\n  fill: ", ";\n  \n  cursor: ", ";\n"])), space, function (props) { return props.width || '24px'; }, function (props) { return props.height || '24px'; }, function (props) {
    if (!props.color)
        return null;
    else if (props.theme.palette.hasOwnProperty(props.color))
        return props.theme.palette[props.color];
    else
        return props.color;
}, function (props) { return props.pointer ? 'pointer' : null; });
var templateObject_1;
